import type { Dispatch, SetStateAction } from 'react'
import { shouldRequestSDK } from './abTestHelpers'

export function requestSDK(
	abRequested: boolean,
	preventRequestSDK: boolean,
	setAbRequested: Dispatch<SetStateAction<boolean>>
) {
	if (shouldRequestSDK(abRequested, preventRequestSDK)) {
		setAbRequested(true)
	}
}
